import  { useState } from "react";
import styled from "styled-components";
import { Text } from "@mantine/core";
import { FaWhatsapp } from "react-icons/fa";
import mortgageexpertsone from "../assets/images/mortgageexpertsone.png";
import mortgageexpertstwo from "../assets/images/mortgageexpertstwo.png";
import mortgageexpertsthree from "../assets/images/mortgageexpertsthree.png";
import mortgageexpertsfour from "../assets/images/mortgageexpertsfour.png";

const OuterContainer = styled.div`
  color: white;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

// Container for all cards
const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 2rem 5%;
  background-color: #000; /* Dark background */

  /* Media query for smaller screens */
  @media (max-width: 868px) {
    flex-direction: column;
    align-items: center;
     padding: 0;
  }
`;

// Individual Card styles
const Card = styled.div`
  background-color: transparent;
  border-radius: 15px;
  width: 23%;
  text-align: center;
  border: 1px solid rgb(167, 140, 76);
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(167, 140, 76);
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 868px) {
    width: 100%;
    margin-bottom: 1.5rem;
  }
`;

// Icon styles
const Icon = styled.div`
  color: rgb(167, 140, 76);
  transition: all 0.3s ease;

  ${Card}:hover & {
    color: white;
  }
`;

// Title styles
const Title = styled.h3`
  color: rgb(167, 140, 76);
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  margin-top: 0;
  transition: all 0.3s ease;
  ${Card}:hover & {
    color: white;
  }
`;

// Description styles
const Description = styled.p`
  color: #666;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  ${Card}:hover & {
    color: white;
  }
`;
const Button = styled.button`
  margin-top: 2rem;
  padding: 0.5rem 1rem;
  background-color: rgb(167, 140, 76);
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.3s ease;
  justify-content: center;
  width: 100%;
  border: 1px solid;
  border-radius: 7px;
  svg {
    font-size: 1.2rem;
  }
  &:hover {
    background-color: #000;
  }
`;
const ResponsiveText = styled(Text)`
  font-size: 3rem;
  font-weight: 500;
  font-family: "Paris Avenue";
  margin-top: 1.5rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
     margin-top: 0rem;
  }
`;
const MortgageLeaders = () => {
  const [selectedCard, setSelectedCard] = useState(0); // State to track selected card

  // Function to handle card click
  const handleCardClick = (cardIndex) => {
    setSelectedCard(cardIndex);
  };

  return (
    <OuterContainer id="whyus">
      <Text
      className="mortgage-leaders-responsive-heading"
        weight={700}
      >
        <ResponsiveText>Mortgage experts for a reason.
        <br /> We can help you with the following services</ResponsiveText>
      </Text>

      <CardContainer>
        {/* Card 1 */}
        <Card highlight={selectedCard === 0} onClick={() => handleCardClick(0)}>
          <Icon highlight={selectedCard === 0}>
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={mortgageexpertsone}
            />
          </Icon>
          <div style={{ padding: "1rem" }}>
            <Title highlight={selectedCard === 0}>"Resident mortgages"</Title>
            <Description highlight={selectedCard === 0}>
              Using our extensive knowledge of the UAE home loan market and
              property transaction process we'll take the hassle out of getting
              your mortgage.
            </Description>
            <Button
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=",
                  "_blank"
                );
              }}
            >
              Connect With Expert <FaWhatsapp />
            </Button>
          </div>
        </Card>

        {/* Card 2 */}
        <Card highlight={selectedCard === 1} onClick={() => handleCardClick(1)}>
          <Icon highlight={selectedCard === 1}>
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={mortgageexpertstwo}
            />
          </Icon>
          <div style={{ padding: "1rem" }}>
            <Title highlight={selectedCard === 1}>
              "Non-resident mortgages"
            </Title>
            <Description highlight={selectedCard === 1}>
              If you're looking to buy in Dubai, Abu Dhabi or anywhere else in
              the UAE, we can assist with our low-documentation exclusive
              mortgage offers.
            </Description>
            <Button
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=",
                  "_blank"
                );
              }}
            >
              Connect With Expert <FaWhatsapp />
            </Button>
          </div>
        </Card>

        {/* Card 3 */}
        <Card highlight={selectedCard === 2} onClick={() => handleCardClick(2)}>
          <Icon highlight={selectedCard === 2}>
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={mortgageexpertsthree}
            />
          </Icon>
          <div style={{ padding: "1rem" }}>
            <Title highlight={selectedCard === 2}>
              "Equity release / Buyouts"
            </Title>
            <Description highlight={selectedCard === 2}>
              We can help you unlock equity from a property you already own, or
              refinance an existing mortgage if you're currently paying too
              much.
            </Description>
            <Button
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=",
                  "_blank"
                );
              }}
            >
              Connect With Expert <FaWhatsapp />
            </Button>
          </div>
        </Card>

        {/* Card 4 */}
        <Card highlight={selectedCard === 3} onClick={() => handleCardClick(3)}>
          <Icon highlight={selectedCard === 3}>
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={mortgageexpertsfour}
            />
          </Icon>
          <div style={{ padding: "1rem" }}>
            <Title highlight={selectedCard === 3}>"Commercial finance"</Title>
            <Description highlight={selectedCard === 3}>
              Whether you're looking to buy a new building, or release equity on
              an existing one, our experience mortgage consultants have the
              answer.
            </Description>
            <Button
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=",
                  "_blank"
                );
              }}
            >
              Connect With Expert <FaWhatsapp />
            </Button>
          </div>
        </Card>
      </CardContainer>
    </OuterContainer>
  );
};

export default MortgageLeaders;
